import Vue from 'vue'
import VueI18n from 'vue-i18n'

import localeId from './locale/id.json'
import localeZhTw from './locale/zh-Hant.json'
import localeEn from './locale/en.json'
import localeTh from './locale/th.json'
import localeVi from './locale/vi.json'

Vue.use(VueI18n)

const locale = 'en'
const messages = {
  'id': localeId,
  'zh': localeZhTw,
  'en': localeEn,
  'th': localeTh,
  'vi': localeVi
}
const i18n = new VueI18n({
  locale,
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js